import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
export default function Educationmanagementsystem() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  return (
    <div>
      <Helmet>
        <title>Best School Management Software - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/school-management-system/" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              CapoBrain - School Management System
            </h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mt-5">
        <div className="section-title text-center">
          <h2>Manage Your School Efficiently</h2>
          <h3>
          CapoBrain -  <span> School Management System</span>
          </h3>
        </div>
        <p style={{ textAlign: "justify" }}>
          <a href="https://capobrain.com/" target="_blank" rel="noopener" style={{ textDecoration: "none" }}>
            CapoBrain
          </a>{" "}
          is a school management system that simplifies administrative tasks and facilitates communication between
          teachers, staff, and parents. Its intuitive interface and robust capabilities make managing student
          information, scheduling classes, and tracking attendance a breeze.
        </p>
    <p>
  CapoBrain Learning Administration also includes features for teachers to create and assign tasks and for
  parents to stay updated on their child's progress. CapoBrain excels in accounts and inventory management,
  providing financial platform tools to track expenses, income, and budget, enabling informed decisions. It
  also allows schools to monitor their resources and equipment, generate usage reports, and keep track of stock
  levels. To understand how we handle your data .
  <br />
  <Link to="/capobrain-privacy-policy" style={{ color: primaryColor, textDecoration: "none", fontWeight: "600" }}>
    Read CapoBrain Privacy Policy →
  </Link>
</p>
       

      </div>

      {/* Feature Cards - stronger border */}
      <div className="container mb-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="row g-4">
          {[
            { icon: "fa-chart-line", title: "Admin Dashboard" },
            { icon: "fa-users", title: "Staff Management" },
            { icon: "fa-graduation-cap", title: "Student Management" },
            { icon: "fa-warehouse", title: "Inventory Management" },
            { icon: "fa-money-bill", title: "Fee Management" },
            { icon: "fa-id-card", title: "Account Management" },
            { icon: "fa-square-poll-horizontal", title: "Results Management" },
            { icon: "fa-book", title: "Syllabus Management" },
            { icon: "fa-book-open-reader", title: "Library Management" },
            { icon: "fa-money-check-dollar", title: "Expense Management" },
            { icon: "fa-chart-pie", title: "Conclusive Reporting" }
          ].map((item, i) => (
            <div className="col-md-4" key={i}>
              <div
                className="card shadow-sm h-100"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',           // ← clearer border
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-8px) scale(1.025)';
                  e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;  // border changes on hover
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#a0a0a0';     // back to original
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <div className="card-body d-flex align-items-center">
                  <i
                    className={`fa-solid ${item.icon} me-3 fa-lg`}
                    style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                  ></i>
                  <p className="card-title mb-0">{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Who Is This For? */}
      <div className="container my-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-2">
          <h3>Who Is This For?</h3>
        </div>
        <div className="row g-4">
          {[
            { icon: "fa-school", text: "Schools & Colleges – Simplify daily operations, academic management, and administration." },
            { icon: "fa-user-tie", text: "School Administrators – Centralized control over students, staff, finances, and reports." },
            { icon: "fa-chalkboard-teacher", text: "Teachers – Easy class management, attendance tracking, assignments, and grading." },
            { icon: "fa-user-friends", text: "Parents – Real-time access to attendance, academic progress, and school updates." },
            { icon: "fa-university", text: "Educational Institutions & Academies – Scalable solution suitable for small to large institutions." },
            { icon: "fa-users-cog", text: "Education Management Teams – Streamlined oversight of operations, performance, analytics, and institutional growth." }
          ].map((item, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className="card shadow-sm h-100"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-8px) scale(1.025)';
                  e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#a0a0a0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <div className="card-body text-center p-4">
                  <i
                    className={`fa-solid ${item.icon} fa-2x mb-3`}
                    style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                  ></i>
                  <p className="mb-0 fw-medium">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Key Modules Explained */}
      <div className="container my-5" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
        <div className="section-title text-center mb-5">
          <h3>Key Modules Explained</h3>
        </div>
        <div className="row g-4">
          {[
            { icon: "fa-tachometer-alt", title: "Admin Dashboard", desc: "Real-time insights into academics, finance, attendance, and school performance." },
            { icon: "fa-user-graduate", title: "Student Management", desc: "Profiles, admissions, history, attendance & progress tracking in one place." },
            { icon: "fa-users-cog", title: "Staff & Teacher Management", desc: "Records, roles, permissions, attendance, payroll & performance." },
            { icon: "fa-check-circle", title: "Attendance Management", desc: "Automated tracking with instant reports and summaries." },
            { icon: "fa-file-invoice-dollar", title: "Fee & Accounts Management", desc: "Fee collection, invoices, payments, expenses & financial reports." },
            { icon: "fa-boxes", title: "Inventory & Asset Management", desc: "Track assets, inventory, usage and maintenance." },
            { icon: "fa-file-alt", title: "Examination & Results", desc: "Create exams, grading, publish results & report cards." },
            { icon: "fa-book", title: "Library Management", desc: "Books, issue/return, cataloging & overdue tracking." },
            { icon: "fa-chart-bar", title: "Reports & Analytics", desc: "Comprehensive academic, financial & admin reports." }
          ].map((item, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className="card shadow-sm h-100"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-8px) scale(1.025)';
                  e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#a0a0a0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <div className="card-body text-center p-4">
                  <i
                    className={`fa-solid ${item.icon} fa-2x mb-3`}
                    style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                  ></i>
                  <h5 className="card-title mb-3">{item.title}</h5>
                  <p className="card-text small">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Why Choose CapoBrain? */}
      <div className="container my-2 py-2" data-aos="fade-up" style={{ background: `rgba(${parseInt(primaryColor.slice(1,3),16)}, ${parseInt(primaryColor.slice(3,5),16)}, ${parseInt(primaryColor.slice(5,7),16)}, 0.03)` }}>
        <div className="section-title text-center mb-5">
          <h3>Why Choose CapoBrain? </h3>
        </div>
        <div className="row g-4 justify-content-center">
          {[
            { icon: "fa-layer-group", text: "All-in-One Solution – Academics, admin, finance & communication" },
            { icon: "fa-smile", text: "User-Friendly Interface – Minimal training required" },
            { icon: "fa-shield-alt", text: "Highly Secure – Advanced data protection" },
            { icon: "fa-expand-arrows-alt", text: "Scalable & Customizable – Grows with your institution" },
            { icon: "fa-clock", text: "Real-Time Access – Instant updates for all stakeholders" },
            { icon: "fa-coins", text: "Cost-Effective – Reduces paperwork & operational costs" },
          ].map((item, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className="card shadow-sm h-100"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-8px) scale(1.025)';
                  e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#a0a0a0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <div className="card-body text-center p-4">
                  <i
                    className={`fa-solid ${item.icon} fa-2x mb-3`}
                    style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                  ></i>
                  <p className="mb-0 fw-medium">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Security & Compliance */}
      <div className="container my-5" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
        <div className="section-title text-center mb-5">
          <h3>Security & Compliance</h3>
          <p className="lead">CapoBrain prioritizes data protection and system reliability:</p>
        </div>
        <div className="row g-4">
          {[
            { icon: "fa-user-lock", text: "Role-Based Access Control – Authorized access only" },
            { icon: "fa-key", text: "Secure Authentication – Encrypted login & verification" },
            { icon: "fa-database", text: "Regular Data Backups – Prevents data loss" },
            { icon: "fa-user-shield", text: "Data Privacy Protection – Safeguards personal information" },
            { icon: "fa-search", text: "System Monitoring – Prevents unauthorized access" },
            { icon: "fa-certificate", text: "Compliance-Ready – Aligns with modern security standards" }
          ].map((item, i) => (
            <div className="col-md-6" key={i}>
              <div
                className="card shadow-sm h-100"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-8px) scale(1.025)';
                  e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#a0a0a0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <div className="card-body d-flex align-items-center p-4">
                  <i
                    className={`fa-solid ${item.icon} fa-lg me-3`}
                    style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                  ></i>
                  <p className="mb-0">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modern Benefits Section */}
      <div className="benefits my-5" id="services-section" data-aos="fade-up" data-aos-duration="1000">
        <div className="container py-5">
          <div className="section-title text-center mb-5">
            <h3>Benefits To Use  <span>School Management</span> System</h3>
          </div>
          <div className="row g-4">
            {[
              { icon: "fa-check-double", title: "Automated Attendance Tracking", desc: "Simplifies attendance management by automatically recording student attendance, reducing manual entry errors, and saving time for teachers." },
              { icon: "fa-comments", title: "Parent-Teacher Communication", desc: "Provides a seamless channel for communication between parents and teachers through messaging and notifications." },
              { icon: "fa-file-signature", title: "Grade and Report Card Generation", desc: "Automatically calculates and generates grades and report cards, ensuring accuracy and timely delivery." },
              { icon: "fa-file-invoice-dollar", title: "Fee Management", desc: "Simplifies fee collection, tracks payments, and manages student accounts with detailed financial reports." },
              { icon: "fa-shield-alt", title: "Data Security", desc: "Protects sensitive student and staff data with robust security measures and regular backups." },
              { icon: "fa-user-graduate", title: "Student Profiles", desc: "Maintains detailed student profiles, including academic records, attendance, and personal information." },
              { icon: "fa-thumbs-up", title: "Intuitive Design", desc: "Ensures ease of use with a user-friendly interface that requires minimal training for staff and students." },
              { icon: "fa-book-open", title: "Library Management", desc: "Simplifies the management of library resources, including book issuance, returns, and cataloging." },
              { icon: "fa-chart-line", title: "Detailed Reports", desc: "Generates comprehensive reports on various aspects such as academic performance and attendance." },
              { icon: "fa-cogs", title: "Customizable Modules", desc: "Tailors the software to meet the specific needs of your institution with customizable modules and features." },
              { icon: "fa-dollar-sign", title: "Reduced Operational Costs", desc: "Lowers administrative costs by automating routine tasks and reducing paper-based processes." },
              { icon: "fa-envelope-open-text", title: "Enhanced Communication", desc: "Facilitates seamless communication between stakeholders, including parents, teachers, and administrators, through instant messaging." }
            ].map((item, i) => (
              <div className="col-md-6 col-lg-4" key={i}>
                <div
                  className="card shadow-sm h-100"
                  style={{
                    transition: 'all 0.28s ease',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    border: '1px solid #a0a0a0',
                    backgroundColor: '#ffffff',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = primaryColor;
                    e.currentTarget.style.color = '#ffffff';
                    e.currentTarget.style.transform = 'translateY(-8px) scale(1.025)';
                    e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.18)';
                    e.currentTarget.style.borderColor = primaryColor;
                    const icon = e.currentTarget.querySelector('i');
                    if (icon) icon.style.color = '#ffffff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'white';
                    e.currentTarget.style.color = 'inherit';
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
                    e.currentTarget.style.borderColor = '#a0a0a0';
                    const icon = e.currentTarget.querySelector('i');
                    if (icon) icon.style.color = primaryColor;
                  }}
                >
                  <div className="card-body p-4">
                    <div className="d-flex align-items-start">
                      <i
                        className={`fa-solid ${item.icon} fa-2x me-3 mb-3`}
                        style={{ color: primaryColor, transition: 'color 0.28s ease', minWidth: '50px' }}
                      ></i>
                      <div>
                        <h5 className="card-title mb-2" style={{ fontSize: '1.1rem' }}>{item.title}</h5>
                        <p className="card-text small" style={{ opacity: 0.9 }}>{item.desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Free Demo */}
      <div className="container mt-5 mb-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-12 mb-4 mb-md-0">
            <div className="section-title text-start">
              <h3>Let's Have A <span>Free Demo</span></h3>
            </div>
            <p className="lead" style={{ textAlign: "justify" }}>
              <strong>See for yourself how our best education management system works:</strong>
            </p>
            <ul className="list-unstyled mt-3">
              <li className="mb-2">
                Go to:{" "}
                <strong>
                  <a href="https://demo.capobrain.com" target="_blank" rel="noreferrer">
                    https://demo.capobrain.com
                  </a>
                </strong>
              </li>
              <li className="mb-2">Username: <strong>CAPOUSER</strong></li>
              <li>Password: <strong>12345678</strong></li>
            </ul>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="ratio ratio-16x9 rounded overflow-hidden shadow">
              <iframe
                src="https://www.youtube.com/embed/7k4E6ZveXkI?si=VUbtIbhiwZis9fQY"
                title="CapoBrain Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}